<script setup>
import TagTable from '@/views/masters/tag/Table.vue'

definePage({
  meta: {
    name: 'incident-master-tag',
    subject: 'incident.menu',
    action: 'master_tag',
  },  
})
</script>

<template>
  <div>
    <TagTable page-type="INCIDENT" />
  </div>
</template>
